<template>
  <div v-if="!alertState.isDismissed" :class="$style.alert_container">
    <button :class="$style.close_button" @click="dismiss">
      <svg class="btn__icon btn__icon--right icon icon-chevron-right">
        <use
          xlink:href="../assets/images/brinkshome_icons.svg#icon-circle-x"
        ></use>
      </svg>
    </button>
    <div :class="$style.alert_text"
      >{{ alertState.msg }} Please call
      <a
        id="link-error-alert-phone"
        :class="$style.phone_link"
        :href="'tel:' + retrievePhoneByRole()"
        >{{ retrievePhoneByRole() }}</a
      >
      for assistance.</div
    >
  </div>
</template>

<script>
import { store } from '../state/store'
import retrievePhoneByRole from '@utils/retrieve-phone-by-role'
export default {
  data() {
    return {
      alertState: store.state.errorAlert,
      state: store.state,
    }
  },
  mounted() {
    if (!store.state.errorAlert.isDismissed) {
      this.dismiss()
    }
  },
  methods: {
    dismiss() {
      store.dismissErrorAlert()
    },
    retrievePhoneByRole() {
      return retrievePhoneByRole()
    },
  },
}
</script>

<style lang="scss" module>
@import '@design';
.close_button {
  float: right;
  background-color: transparent;
  border: 0;
  color: $color-text-secondary;
  cursor: pointer;
  font-size: 1em;
}

.close_button:hover {
  color: $color-danger-text;
}

.alert_container {
  border-radius: 0.25em;
  background-color: $color-danger-bg;
  margin: 1em;
  text-align: center;
  padding: 0.5em;
}

.alert_text {
  color: $color-danger-text;
  font-weight: 500;
  padding-right: 2em;
}

.phone_link {
  color: $color-danger-text;
  text-decoration: underline;
  font-weight: bold;
}
</style>
